import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const AccessButtonContainer = styled.div<React.CSSProperties>`
  position: absolute;
  top: ${Screen.widthRatio * 502.5}px;
  right: ${Screen.widthRatio * 91.5}px;
`;

export default AccessButtonContainer;
